import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.576 16.664V3.83a1.283 1.283 0 0 1 1.283-1.284h3.85a1.283 1.283 0 0 1 1.283 1.284v12.833a1.283 1.283 0 0 1-1.283 1.283h-3.85a1.283 1.283 0 0 1-1.283-1.283m5.133 0V3.83h-3.85v12.833zm-1.925-1.284a.962.962 0 1 0 0-1.924.962.962 0 0 0 0 1.924m-12.618.158L5.035 3.029a1.283 1.283 0 0 1 1.538-.964l3.752.86a1.283 1.283 0 0 1 .964 1.538L8.42 16.971a1.283 1.283 0 0 1-1.537.964l-3.753-.86a1.283 1.283 0 0 1-.964-1.538m5.004 1.147 2.868-12.508-3.752-.86-2.869 12.508zm-1.59-1.68a.963.963 0 1 0 .43-1.878.963.963 0 0 0-.43 1.877" }, null, -1)
  ]))]))
}
export default { render: render }